module.exports = "/static/assets/795573a9d2fee5058a63cf5ec067fa3e.png";